module.exports = __webpack_public_path__ + "static/media/business-river-logo.479674e9.png";